import React from 'react'
import  { useRef } from 'react';
import './Contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiLinkedinLine} from 'react-icons/ri'
import {BsTwitter, BsWhatsapp} from 'react-icons/bs'
import emailjs from 'emailjs-com'
const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ccjlv9i', 'template_snfdbl7', form.current, '4q9dbihw-oQdjH2zY')
   
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };
  return (
    <section id='contacts'>
      <h5>Let's link up</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>iamegyimah@gmail.com</h5>
            <a href="mailto:iamegyimah@gmail.com" target='_blank' rel="noreferrer">Send A message</a>
          </article>
          <article className="contact__option">
            <RiLinkedinLine className='contact__option-icon'/>
            <h4>LinkedIn</h4>
            <h5>Emmanuel Gyimah</h5>
            <a href="www.linkedin.com/in/emmanuel-gyimah-980bb522b" target='_blank'>Send A message</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>+233504086599</h5>
            <a href="https://wa.me/+233504086599" target='_blank' rel="noreferrer">Send A message</a>
          </article>
          <article className="contact__option">
            <BsTwitter className='contact__option-icon'/>
            <h4>Twiiter</h4>
            <h5>@officialegyimah</h5>
            <a href="https://twitter.com/officialegyimah" target='_blank' rel="noreferrer">Send A message</a>
          </article>
        </div>
        {/* END OF OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text"  name='name' placeholder='Your full name' required/>
          <input type='email' name='email' placeholder= 'Your Email' required/>
          <textarea name="message" id="7" cols="30" rows="10" placeholder='Your message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact